import { cn } from '@/lib/utils';

/**
 * Marca do sistema.
 *
 * Os arquivos vêm de `apps/web/public/`:
 * - `logo-marca.png`  — emblema quadrado (cabeçalho, favicon, telas de entrada)
 * - `logo01.jpg`      — logo completa, com o nome e a assinatura
 *
 * O original (`logo01.jpg`, na raiz do projeto) foi redimensionado para 1000 px
 * de largura sem alterar o desenho.
 */
export function MarcaMiolos({ className, tamanho = 32 }: { className?: string; tamanho?: number }) {
  return (
    <img
      src="/logo-marca.png"
      alt="Miolix — miolos de papelaria personalizada"
      width={tamanho}
      height={tamanho}
      className={cn('shrink-0 select-none rounded-md object-contain', className)}
      style={{ width: tamanho, height: tamanho }}
      draggable={false}
    />
  );
}

export function LogoCompleta({ className }: { className?: string }) {
  return (
    <img
      src="/logo01.jpg"
      alt="Miolix — A plataforma ágil para organizar, gerar e controlar miolos de papelaria personalizada"
      className={cn('h-auto w-full max-w-sm select-none object-contain', className)}
      draggable={false}
    />
  );
}
